// This function generates mostly unique ids, which are acceptable in many cases
// If you need absolutely no collisions, do not use this function.
// https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript

/* eslint-disable */
export const generateNearlyUniqueID = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const UUID = { generateNearlyUniqueID };

export default UUID;
/* eslint-enable */
